/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['#edit-treatment[_ngcontent-%COMP%]   .nav-type.line[_ngcontent-%COMP%] {\n  padding: 25px 0;\n}\n#edit-treatment[_ngcontent-%COMP%]   .nav-type.line[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] {\n  display: inline-block;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL2FsbC10cmVhdG1lbnRzL2FsbC10cmVhdG1lbnRzLmNvbXBvbmVudC5sZXNzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL2FsbC10cmVhdG1lbnRzL2FsbC10cmVhdG1lbnRzLmNvbXBvbmVudC5sZXNzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/custom/all-treatments/all-treatments.component.less.shim.ngstyle.ts